import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	starred: {
		defaultMessage: 'Starred',
		id: 'atlassian-navigation.dashboards.menu.favorite-content.starred',
		description: 'Starred dashboard item',
	},
});
